// Constants.js
export const CON_STATUS_ZERO = "0";
export const CON_STATUS_NONE = "";
export const CON_DEFAULT_IMG = "https://fileserver.eskaiy.dev/COMMON/DEF_IMGS/noimage.png";
export const CON_DEFAULT_PNG = "https://fileserver.eskaiy.dev/COMMON/DEF_IMGS/noimage.png";
export const CON_DEFAULT_NOIMAGE= "https://fileserver.eskaiy.dev/COMMON/DEF_IMGS/noimage.png";
export const CON_VALUE_ZERO = 0;
export const CON_EMPTY_VALUE = "";
export const CON_VALUE_ZERO_ST = "0.00";
export const EXCHANGE_RATE_DEFAULT = "1";

export const CON_STATUS_ACTIVE = "A";
export const CON_BUSINESS_TYPECODE = "O";

export const CON_STATUS_RESTAURANTS = "R";
export const CON_STATUS_KITCHEN = "K";

export const CON_STATUS_NEW = "N";
export const CON_STATUS_NO = "N";


export const CON_DEFAULT_DATE = "0001-01-01";


export const CON_STATUS_Saved = "1";
export const CON_STATUS_PENDING = "2";
export const CON_STATUS_Submited = "3";
export const CON_STATUS_APPROVED = "4";
export const CON_STATUS_REJECTED = "5";
export const CON_STATUS_CANCEL_modifiy = "6";
export const CON_STATUS_RETURN = "7";
export const CON_STATUS_HOLDREJECTED = "8";
export const CON_STATUS_RETURNSUBMITTED = "9";
export const CON_STATUS_RETURNAPPROVED = "10";
export const CON_STATUS_RETURNREJECTED = "11"; 
export const CON_STATUS_RETURNSAVED = "12"; 
 export const CON_STATUS_RETURN_SUBMITTED= "13";
// You can adjust these names as needed
export const SUPPLIER_TYPE_MAP = {
  1: { label: "Saved", color: "success" },
  2: { label: "Pending", color: "warning" },
  3: { label: "Submitted", color: "info" },
  4: { label: "Approved", color: "success" },
  5: { label: "Rejected", color: "error" },
  6: { label: "Cancel/Modify", color: "secondary" },
  7: { label: "Returned", color: "primary" },
};

export const CON_STATUS_RECEIVED = "R";
export const CON_STATUS_DELETED = "D";

export const CON_MENU_TYPE_CODE = "F";

export const CON_IS_CASHIER_YES = "Y";
export const CON_IS_CASHIER_NO = "N";
export const CON_IS_CREDIT_NO = "N";

export const CON_YES = "Y";
export const CON_NO = "N";

export const CON_CAT_TYPE_RESTAURANT = "R";
export const CON_CAT_TYPE_POS = "P";

// Cashier page
export const CON_ADDON_CODE = "0";
export const CON_IS_ADDON = "N";
export const CON_CODENRATE = "0";
export const CON_TAX_PAGE_CODE = "IM";
export const CON_TAX_CODE = "1017";
export const CON_TAX_RATE = "10";
export const CON_TAX_AMOUNT = "60";

export const CON_DELIVERY_STS = "Y";
export const CON_GUEST_REF_CODE = "GREF001";
export const CON_IP_ADDRESS = "192.168.1.1";
export const CON_DEF_WAITING_TIME = 2000;

export const CON_MENUICON_WIDTH = 128;
export const CON_MENUICON_HEIGHT = 128;
export const CON_MAX_FILESIZE_ITEMIMG = 1048576;
export const CON_MAX_FILESIZE_PROMO = 1048576;
// user page
export const CON_DEFAULT_USER_PW = "0";

export const CON_MODULECODE = "8";
export const CON_PASSWORD_USER = "123";

export const CON_MODULEKEY = "As3yhEHzU6HjqCdnqgJonACvJLGhxyHI";

// export const GUEST_PAGE_URL =
//   "Guest?compcode=Q1AyMjAwMDAxMDc=&  LOCCODE:STAFFMAPLOCODE,=TVJUTUNMQzAwNTk=&restcode=NA==";
// export const GUEST_CHECKOUT_URL =
//   "GuestCheckCON_TRSTS_RETURNout?compcode=Q1AyMjAwMDAxMDc=&  LOCCODE:STAFFMAPLOCODE,=TVJUTUNMQzAwNTk=&restcode=NA==";
 
//GRN STATUS
export const CON_TRSTS_RETURN = "2";
export const CON_GRN_STATUS_SAVED = "2";
export const CON_GRN_STATUS_HOLD = "3";
export const CON_GRN_STATUS_SUBMIT = "1";

export const CON_GRN_STATUS_APPROVE = "4";
export const CON_GRN_STATUS_REVOKE = "5";
export const CON_GRN_STATUS_REVERSE = "6";
export const CON_GRN_STATUS_RETURN = "6";
export const CON_GRN_STATUS_APPROVE_RETURN = "8";

// export const GRN_STATUS_MAP = {
//   1: { label: "SAVED", color: "info" },
//   2: { label: "HOLD", color: "warning" },
//   3: { label: "SUBMIT", color: "primary" },
//   4: { label: "APPROVE", color: "success" },
//   5: { label: "REJECT", color: "error" },
//   6: { label: "REJECT_EDIT", color: "error" },
//   7: { label: "RETURN", color: "warning" },
//   8: { label: "APPROVE RETURN", color: "success" },
// };

export const CON_NOTE_GRN = "GRN";
export const CON_NOTE_RETURN = "RN";
export const CON_NOTE_REJECT = "REJ";
export const CON_NOTE_DEBIT = "DN";
export const CON_NOTE_DELIVERY = "DL";


export const CON_PARAID = 24;